import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiResultModel, getCategoriesFromApi } from "@tSchaedlerYesco/Services/DocumentsSearchService";
import { CustomApiHandler } from "@tSchaedlerYesco/Store/CustomHandlerCreator";

export interface Parameter {
    query?: string;
    onError?: (errorMessage: string) => void;
}

type HandlerType = CustomApiHandler<Parameter, ApiResultModel>;

export const StartLoading: HandlerType = props => {
    props.dispatch({
        type: "Custom/SearchResults/StartFetchingCategories",
    });
};

export const GetCategories: HandlerType = async props => {
    if (props.parameter.query) {
        try {
            const result = await getCategoriesFromApi({ query: props.parameter.query });
            props.dispatch({
                type: "Custom/SearchResults/SetCategories",
                categories: result.categories,
            });
        } catch (error) {
            if (isApiError(error) && error.status === 400) {
                props.apiResult.errorMessage = error.errorJson.message;
                return;
            }
            throw error;
        }
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (props.apiResult?.errorMessage) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const UpdateCategoriesQuery: HandlerType = props => {
    if (props.parameter.query) {
        props.dispatch({
            type: "Custom/SearchResults/UpdateCategoriesQuery",
            query: props.parameter.query,
        });
    }
};

export const chain = [UpdateCategoriesQuery, StartLoading, GetCategories, ExecuteOnErrorCallback];

const searchCategories = createHandlerChainRunner(chain, "searchCategories");
export default searchCategories;
